/**
 * CardStack (markup in page-20th-anniversary.php & metered-paywall.php)
 */
$(self).ready(() => {
  const allStacks = document.querySelectorAll('.CardStack')
  if (!allStacks.length) return

  function unblockStack(stack, pos) {
    stack.prepend(stack.children[pos])
    stack.children[0].classList.remove('--out')
    stack.classList.remove('--pointer-events-none')
  }

  function MoveCards(stack) {
    const len = stack.children.length
    stack.classList.add('--pointer-events-none')
    stack.children[len - 1].classList.remove('--pos-0')
    stack.children[len - 1].classList.add('--out')

    stack.children[len - 2].classList.remove('--pos-1')
    stack.children[len - 2].classList.add('--pos-0')

    stack.children[len - 3].classList.remove('--pos-2')
    stack.children[len - 3].classList.add('--pos-1')

    stack.children[len - 4].classList.remove('--pos-3')
    stack.children[len - 4].classList.add('--pos-2')

    stack.children[len - 5].classList.remove('--pos-4')
    stack.children[len - 5].classList.add('--pos-3')

    stack.children[len - 6].classList.add('--pos-4')

    setTimeout(function () {
      unblockStack(stack, len - 1)
    }, 750)
  }

  allStacks.forEach(function (stack) {
    for (let Card of stack.children) {
      Card.onclick = function () {
        MoveCards(stack)
      }
      $(Card).on('swiperight', () => {
        MoveCards(stack)
      })
    }
  })
})
